module.exports = __webpack_public_path__ + "assets/img/destroy_team_active.e6bdf10c.png";